import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { DeathData } from '@/domain/deathData/deathData'
import { AlertTriangle } from 'lucide-react'

interface DeleteDeathDataModalProps {
  isOpen: boolean
  onClose: () => void
  record: DeathData
  onConfirm: () => void
}

export const DeleteDeathDataModal = ({ isOpen, onClose, record, onConfirm }: DeleteDeathDataModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-600">
            <AlertTriangle className="h-5 w-5" />
            Eliminar Ocupante
          </DialogTitle>
          <DialogDescription>
            ¿Está seguro de que desea eliminar a <strong>{record.name}</strong>?
            Esta acción se registrará en el historial de eventos una vez que confirme los cambios.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-4">
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button variant="destructive" onClick={onConfirm}>Eliminar Ocupante</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
